import { joinChannel, leaveChannel } from './ws-actions';
import { getChannel } from '../services/ws-channel';
import { showNewPostMessageDebounced } from './show-new-post-message';
import * as WS_EVENTS from '../../../universal/constants/ws-events';

import { fetchPost } from './fetch-post';

export const emitOpenCategory = category =>
  joinChannel(getChannel({ type: 'category', ...category }));
export const emitCloseCategory = category =>
  leaveChannel(getChannel({ type: 'category', ...category }));

export const SOCKET_NEW_POST = WS_EVENTS.NEW_POST;
export const UPDATE_POST_COUNTERS = 'post/UPDATE_POST_COUNTERS';
export const SOCKET_UPDATE_POST_COUNTERS = WS_EVENTS.UPDATE_POST_COUNTERS;

export const UPDATE_CATEGORY_COUNTERS = 'category/UPDATE_CATEGORY_COUNTERS';
export const SOCKET_UPDATE_CATEGORY_COUNTERS = WS_EVENTS.UPDATE_CATEGORY_COUNTERS;

export const newPost = payload => dispatch => {
  dispatch(fetchPost(payload.slug));
  dispatch(showNewPostMessageDebounced(payload._id));
};

export const updatePostCounters = payload => dispatch =>
  dispatch({
    type: UPDATE_POST_COUNTERS,
    payload,
  });

export const updateCategoryCounters = payload => dispatch =>
  dispatch({
    type: UPDATE_CATEGORY_COUNTERS,
    payload,
  });
